import type React from 'react';
import { cn, looksArabic } from '@/lib/utils';

interface BiTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: string;
  as?: 'span' | 'div' | 'p';
}

/**
 * SPEC §11 — bilingual text helper.
 * Always `dir="auto"`; adds `lang="ar"` and the self-hosted Noto Naskh Arabic
 * face when the string looks Arabic, so EN and AR cells can share one component.
 */
export function BiText({ children, className, as = 'span', ...props }: BiTextProps): React.JSX.Element {
  const arabic = looksArabic(children);
  const Component = as;
  return (
    <Component
      dir="auto"
      {...(arabic ? { lang: 'ar' } : {})}
      className={cn(arabic ? 'text-arabic' : 'text-auto', className)}
      {...props}
    >
      {children}
    </Component>
  );
}
